import config from "../config"
const base_url = config.base_url
export const requestOTPsecret=()=>{
    return new Promise((resolve, reject) => {
        fetch(base_url+'user/requestOTPsecret', {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            'credentials':'include'
        },
        credentials:'include'
        }).then((res)=>{
            if (res.status===200) return res.text()
            else throw new Error (res.status)
        }).then(e=>{
            resolve(e)
        }).catch(e=>{
            console.log(e)
            reject()
        })
    })
}

export const revokeMFA = () =>{
    return new Promise((resolve, reject) => {
        fetch(base_url+'user/mfa/remove', {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            'credentials':'include'
        },
        credentials:'include'
        }).then((res)=>{
            if (res.status===200) return res.text()
            else throw new Error (res.status)
        }).then(e=>{
            resolve(e)
        }).catch(e=>{
            console.log(e)
            reject()
        })
    })
}
export const activateMFA = () =>{
    return new Promise((resolve, reject) => {
        fetch(base_url+'user/mfa/activate', {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            'credentials':'include'
        },
        credentials:'include'
        }).then((res)=>{
            if (res.status===200) return res.text()
            else throw new Error (res.status)
        }).then(e=>{
            resolve(e)
        }).catch(e=>{
            console.log(e)
            reject()
        })
    })
}
